// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3ECdT","image":"style_image__1w4A3"};